import { render, staticRenderFns } from "./SetorUnidade.vue?vue&type=template&id=845e1f8e"
import script from "./SetorUnidade.vue?vue&type=script&lang=js"
export * from "./SetorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports